// extracted by mini-css-extract-plugin
module.exports = {"pagination":"List_pagination_1XkJx","paginationText":"List_paginationText_3rqdM","paginationButton":"List_paginationButton_3l0io"};